import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {normalize, schema} from 'normalizr'
import {emptyObject} from '../helpers/emptyObjects'
import {baseFieldTypes} from './base/baseFieldTypes'
import {baseItemSchema, channelSchema, userSchema} from './schema'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

const fields = [
    'user_id', // auto fill = creator
    'owner_id', // user or organization
    'owner_type', // user or organization
    'categories', // user or organization
    'title', // required|max:100
    'description', //max:10000
    'about', // max:65000
    'idname', // unique:channels,idname
    'avatar', // avatar
    'status', // -1, 1, 9
    'active', // 0 / 1
    'privacy', // 1 / 2
    'public', // 0 / 1
    'exclude_promos', // 0 / 1
    'post_policy', // 1 = published immediately, 2 = requires approval
]

const fieldTypes = {
    user_id: baseFieldTypes.auto,
    owner_id: baseFieldTypes.string,
    owner_type: baseFieldTypes.string,
    avatar: baseFieldTypes.image,
    thumbnail: baseFieldTypes.auto,
    idname: baseFieldTypes.string,
    // status: baseFieldTypes.status,
    // active: baseFieldTypes.active,
    // certified: baseFieldTypes.certified,
    // privacy: baseFieldTypes.privacy,
    // public: baseFieldTypes.public
}

export const channel_add_Api = {
    backend: `Route::post('channels/add', 'ChannelController@store')`,
    root: API_ROOT_URL,
    path: '/channels/add',
    method: 'POST',
    fields: ['owner_id', 'owner_type'],
    fieldTypes,
    schema: channelSchema,
    transform: createTransform(channelSchema, 'data'),
}

export const channel_edit_Api = {
    backend: `Route::post('channels/{id}/edit', 'ChannelController@update')`,
    root: API_ROOT_URL,
    path: '/channels/:id/edit',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(channelSchema, 'data'),
}

export const channel_resetSecretKey_Api = {
    backend: `Route::post('channels/{id}/renew-secret-key', 'ChannelController@resetSecretKey');`,
    root: API_ROOT_URL,
    path: '/channels/:id/renew-secret-key',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(channelSchema, 'data'),
}


export const channel_delete_Api = {
    backend: ` Route::post('channels/{id}/delete', 'ChannelController@deletePollQuestion')`,
    root: API_ROOT_URL,
    path: '/channels/:id/delete',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(channelSchema, 'data'),
}

export const channel_getTypicalChannels_Api = {
    backend: `Route::get('channels/get-typical-channels', 'ChannelController@getTypicalChannels');`,
    root: API_ROOT_URL,
    path: '/channels/get-typical-channels',
    method: 'GET',
    fields,
    fieldTypes,
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const channel_getFollowingUsers_Api = {
    backend: `Route::get('channels/{id}/get-following-users', 'ChannelController@getFollowingUsers');`,
    root: API_ROOT_URL,
    path: '/channels/:id/get-following-users',
    method: 'GET',
    fields,
    schema: userSchema,
    fieldTypes,
    transform: createListTransform(userSchema),
}

export const channel_getById_Api = {
    backend: `Route::get('channels/{id}/get', 'ChannelController@getById');`,
    root: API_ROOT_URL,
    path: '/channels/:id/get',
    method: 'GET',
    fields,
    fieldTypes,
    transform: createTransform(channelSchema, 'data'),
}

export const getChannelsByProps_Api = {
    backend: `Route::get('channels/{type}/{id}/gets', 'ChannelController@getChannelsByProps')`,
    root: API_ROOT_URL,
    path: '/channels/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by'],
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const getChannelsByOrganization_Api = {
    backend: `Route::get('channels/organization/{id}/gets', 'ChannelController@getChannelsByProps')`,
    root: API_ROOT_URL,
    path: '/channels/organization/:id/gets',
    method: 'GET',
    fields,
    fieldTypes,
    transform: (response, {query}) => {
        let error, errorMessages, entities, result, success
        const {status} = response || emptyObject
        const data = _.get(response, 'data.data')
        switch (status) {
            case 200:
                success = true
                const {entities: e, result: r} = normalize(
                    data,
                    new schema.Entity(
                        'organizations',
                        {
                            channels: [channelSchema],
                        },
                        {
                            idAttribute: () => query[':id'],
                            processStrategy: (entities) => {
                                return {
                                    idname: query[':id'],
                                    channels: data,
                                }
                            },
                        }
                    )
                )
                entities = e
                result = r
                break

            default:
                error = true
                errorMessages = response.data
                break
        }

        return {
            ...response,
            response,
            error,
            errorMessages,
            success,
            status,
            entities,
            result,
        }
    },
}

export const channel_getChannelsByCategory_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/channels/category/:category_id/gets',
    method: 'GET',
    paramsFields: ['exclude_promos'],
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const channel_getContentUpdatedTimestamp_Api = {
    name: 'channel_getContentUpdatedTimestamp',
    backend: ``,
    root: API_ROOT_URL,
    path: '/channels/:id/get-content-update-timestamp',
    method: 'GET',
}

export const channel_markAsRead_Api = {
    name: 'channel_markAsRead',
    backend: ``,
    root: API_ROOT_URL,
    path: '/channels/:id/mark-as-read',
    method: 'POST',
    transform: createTransform(channelSchema, 'data'),
}

export const channel_manageChannelSubscriptionAdd_Api = {
    name: 'channel_manageChannelSubscriptionAdd',
    backend: ``,
    root: API_ROOT_URL,
    path: '/channels/channel/:channel_id/user/:user_id/set-subscription',
    method: 'POST',
}

export const channel_editSubscription_Api = {
    name: 'channel_editSubscription',
    backend: ``,
    root: API_ROOT_URL,
    path: '/channels/channel-subscription/:channel_subscription_id/edit',
    method: 'POST',
    transform: createTransform(baseItemSchema, 'data'),
}

export const feed_fetchSponsoredChannels_Api = {
    backend: `Route::get('channels/sponsored/gets', 'NewsController@getSponsoredChannels');`,
    root: API_ROOT_URL,
    path: '/channels/sponsored/gets',
    method: 'GET',
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const user_fetchSuggestionChannelAppChoices_Api = {
    name: 'user_fetchSuggestionChannelAppChoices_Api',
    backend: `Route::get('recommendations/channel/suggested-items', 'PromoteController@getChannels');`,
    root: API_ROOT_URL,
    path: '/recommendations/channel/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const channel_getChannels_Api = {
    backend: `Route::get('channels/search', 'ChannelController@searchChannels');`,
    root: API_ROOT_URL,
    path: '/channels/search',
    method: 'GET',
    // certified: 1 — chỉ lấy channel đã verified (dùng cho tab "Kênh Thảo Luận" /discussions, filter ẩn, không có badge UI)
    // has_questions: 1 — chỉ lấy channel có ít nhất 1 câu hỏi (total_asks > 0), cùng dùng cho tab đó
    paramsFields: ['keyword', 'category_id', 'sort-by', 'selected_by_editor', 'certified', 'has_questions'],
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

export const channel_getSummaryChannelArticle_Api = {
    backend: `Route::get('channels/summary', 'ChannelController@fetchChannelSummary');`,
    root: API_ROOT_URL,
    path: '/channels/summary',
    method: 'GET',
    paramsFields: ['type'],
    schema: channelSchema,
    transform: createListTransform(channelSchema),
}

